import { Component } from '@theme/component';
import { animateHeight, cssInterpolatesHeight, motionAllowed } from '@theme/r-motion';

/* ↗ .cursor/references/code-notes/volume-pricing.js.md#§1 */
class VolumePricingComponent extends Component {
  /* ↗ .cursor/references/code-notes/volume-pricing.js.md#§2 */
  toggleExpanded() {
    const wrapper = this.querySelector('.volume-pricing__collapsible-wrapper');
    if (cssInterpolatesHeight || !motionAllowed() || !(wrapper instanceof HTMLElement)) {
      this.classList.toggle('volume-pricing--expanded');
      return;
    }

    // Engines without interpolate-size: play the height as a Web Animation, and on
    // close keep the class until the collapse has played (see r-motion's disclosure note)
    const from = wrapper.getBoundingClientRect().height;
    if (this.classList.contains('volume-pricing--expanded')) {
      const animation = animateHeight(wrapper, from, 0);
      const finish = () => this.classList.remove('volume-pricing--expanded');
      animation ? animation.finished.then(finish).catch(() => {}) : finish();
      return;
    }
    this.classList.add('volume-pricing--expanded');
    animateHeight(wrapper, from, wrapper.scrollHeight);
  }
}

if (!customElements.get('volume-pricing')) {
  customElements.define('volume-pricing', VolumePricingComponent);
}
